import React, { useMemo } from "react";
import { Link, Typography } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { IBreadcrumbsProps } from "./BreadcrumbsListInterfaces";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import { DefaultTranslationFieldsInTable, FAILUREDETAILSSTEPS } from "../../../../../constants/constants";
import { handleNameTranslation, translateDefaultEntity } from "utilities/localesUtilities";
import { useTranslation } from "react-i18next";

export const BreadcrumbsList = ({
    failureDetailsStep,
    failureType,
    area,
    functionalLocation,
    failureCode,
}: IBreadcrumbsProps) => {
    const { i18n } = useTranslation();
    const defaultFailureTypeTranslatedName = translateDefaultEntity(
        i18n.language,
        failureType,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_TYPE,
    );
    const defaultFailureCodeTranslatedName = translateDefaultEntity(
        i18n.language,
        failureCode,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_CODE,
    );
    const areaNameTranslation = useMemo(
        () => (area ? handleNameTranslation(i18n.language, area.translation.translation_names) : ""),
        [i18n.language, area],
    );
    const functionalLocationNameTranslation = useMemo(
        () =>
            functionalLocation
                ? handleNameTranslation(i18n.language, functionalLocation.translation.translation_names)
                : "",
        [i18n.language, functionalLocation],
    );

    return (
        <Breadcrumbs
            separator={<NavigateNextOutlinedIcon fontSize="medium" />}
            color="info.main"
            aria-label="breadcrumb"
        >
            {failureDetailsStep > FAILUREDETAILSSTEPS.FAILURETYPES && (
                <Link underline="hover" color="info.main" href="#">
                    <Typography variant="subtitle1">{defaultFailureTypeTranslatedName}</Typography>
                </Link>
            )}
            {failureDetailsStep > FAILUREDETAILSSTEPS.AREAS && failureType!.is_location_specific && (
                <Link underline="hover" color="info.main" href="#">
                    <Typography variant="subtitle1">{areaNameTranslation}</Typography>
                </Link>
            )}
            {failureDetailsStep > FAILUREDETAILSSTEPS.FUNCTIONALLOCATION && failureType!.is_location_specific && (
                <Link underline="hover" color="info.main" href="#">
                    <Typography variant="subtitle1">{functionalLocationNameTranslation}</Typography>
                </Link>
            )}
            {failureDetailsStep > FAILUREDETAILSSTEPS.FAILURECODES && (
                <Link underline="hover" color="info.main" href="#">
                    <Typography variant="subtitle1">{defaultFailureCodeTranslatedName}</Typography>
                </Link>
            )}
        </Breadcrumbs>
    );
};
